// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"account":"08eac5dd","vendors-node_modules_lodash_pick_js-node_modules_fortawesome_free-solid-svg-icons_index_mjs":"355fc38b","administration":"2605ade7"}[chunkId] + ".chunk.js";
};